/**
 * Activity reducers - used to record when question, WAC and game activities
 * are in progress so that the activityIndex can be sent with analytics.
 * Note: We never clear the activity - events are always marked with the most
 * recent activity, even if that has ended.
 * If the activity index is not available (e.g. in ground) we just use undefined
 */

import { fromJS, Map } from 'immutable';
import { OPEN_WAC_OVERLAY } from '../wac/actions';
import { ACTIVITY_TYPE_WAC, ACTIVITY_TYPE_QUESTION, ACTIVITY_TYPE_GAME } from './activity';
import { SET_QUESTION_ACTIVITY } from '../question-activity/actions';
import { START_GAME_ACTIVITY } from '../games/actions';

export const ACTIVITY_KEY = 'activity';

export function activityReducer(state = Map(), action) {
    let activityIndex = null;

    switch (action.type) {
        case OPEN_WAC_OVERLAY:
            activityIndex = action.activityIndex;
            return setCurrentActivity(state, ACTIVITY_TYPE_WAC, activityIndex);

        case SET_QUESTION_ACTIVITY:
            // Note, in a question activity, the activityIndex has been put
            // inside the info Map:
            const { info } = action;
            activityIndex = info ? info.get('activityIndex') : null;
            return setCurrentActivity(state, ACTIVITY_TYPE_QUESTION, activityIndex);

        case START_GAME_ACTIVITY:
            activityIndex = action.activityIndex;
            return setCurrentActivity(state, ACTIVITY_TYPE_GAME, activityIndex);
    }
    return state;
}

const setCurrentActivity = (state, activityType, activityIndex) =>
    state.set(
        'currentActivity',
        fromJS({
            activityType,
            activityIndex,
        }),
    );
